import { render, staticRenderFns } from "./debt-card-info.vue?vue&type=template&id=0de7b84c"
import script from "./debt-card-info.vue?vue&type=script&lang=ts"
export * from "./debt-card-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports